function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useMemo, useState, useCallback } from "react";

var LocalStorage = /*#__PURE__*/function () {
  function LocalStorage(name) {
    _classCallCheck(this, LocalStorage);

    _defineProperty(this, "name", void 0);

    this.get = this.get.bind(this);
    this.set = this.set.bind(this);
    this.name = name;
  }

  _createClass(LocalStorage, [{
    key: "get",
    value: function get() {
      var str = window.localStorage.getItem(this.name);

      try {
        var obj = JSON.parse(str);
        return obj;
      } catch (_unused) {
        return null;
      }
    }
  }, {
    key: "set",
    value: function set(obj) {
      var str = JSON.stringify(obj);
      return window.localStorage.setItem(this.name, str);
    }
  }, {
    key: "remove",
    value: function remove() {
      window.localStorage.removeItem(this.name);
    }
  }]);

  return LocalStorage;
}();

function useStoredState(key, initialState) {
  var _initialValue;

  var isValid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (d) {
    return true;
  };

  /** React hook for setting and getting values on local storage */
  var storage = useMemo(function () {
    return new LocalStorage(key);
  }, [key]);
  var initialValue = storage.get();
  if (!isValid(initialValue)) initialValue = null;

  var _useState = useState((_initialValue = initialValue) !== null && _initialValue !== void 0 ? _initialValue : initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      _setState = _useState2[1];

  var setState = useCallback(function (nextState) {
    var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (validate && !isValid(nextState)) throw "State ".concat(nextState, " is not valid.");

    _setState(nextState);

    storage.set(nextState);
  }, [isValid]);
  var resetState = useCallback(function () {
    _setState(initialState);

    storage.remove();
  }, [initialState]);
  return [state, setState, resetState];
}

export { LocalStorage, useStoredState };